import { render, staticRenderFns } from "./Cribs.vue?vue&type=template&id=89dda8da&scoped=true"
import script from "./Cribs.vue?vue&type=script&lang=ts"
export * from "./Cribs.vue?vue&type=script&lang=ts"
import style0 from "./Cribs.vue?vue&type=style&index=0&id=89dda8da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89dda8da",
  null
  
)

export default component.exports